import { getApplyConversationActionContext } from 'owa-mail-list-store';
/**
 * Gets contextual information for ApplyConversationAction for a given conversation
 */
export default function getUniqueConversationContextsForRowKey(rowKeys, tableViewId) {
    var conversationActionContexts = [];
    var rowIds = {};
    rowKeys.forEach(function (rowKey) {
        var conversationContext = getApplyConversationActionContext(rowKey, tableViewId);
        // Do not add contexts for duplicate row Ids
        if (!rowIds[conversationContext.conversationId]) {
            rowIds[conversationContext.conversationId] = true;
            conversationActionContexts.push(conversationContext);
        }
    });
    return conversationActionContexts;
}
//# sourceMappingURL=getUniqueConversationContextsForRowKey.js.map